/*! Contains data derived from Unicode CLDR 48.2.
 * Copyright (c) 1991-2025 Unicode, Inc. All rights reserved.
 * Distributed under the Terms of Use in https://www.unicode.org/copyright.html
 * SPDX-License-Identifier: Unicode-3.0
 * The full licence text is THIRD-PARTY-NOTICES.md in this package.
 */
// Generated by tools/gen-data.js from pinned CLDR 48.2. Do not edit by hand.
// Source: lokalized-spec vendor/lokalized-java (cldr-locale-data.aliases.variant).
/** @type {{from: string, to: string}[]} */
const R = [{"from":"heploc","to":"alalc97"},{"from":"polytoni","to":"polyton"}];
/** @returns {{from: string, to: string}[]} */
export const decode = () => R.map((p) => ({ ...p }));
